module.exports = ($scope, $state, $stateParams, $http, $location, $timeout, $window, Api, Login, cfpLoadingBar) ->
  $scope.username = ''
  $scope.password = ''
  $scope.invalid = false
  $scope.cooloff = false
  $scope.waiting = false
  $scope.loginFailed = false
  $scope.badPermission = $stateParams and $stateParams.bad_permission

  $scope.loginFailure = () ->
    $scope.loginFailed = true
    $scope.invalid = true

  $scope.loginSuccess = () ->
    if $stateParams and $stateParams.previous_url
      $location.url($stateParams.previous_url)
    else
      $state.go('start')

  $scope.loginAccessRedirect = () ->
    $window.location.pathname = '/country/'

  $scope.onError  = (data) ->
    $scope.waiting = false
    $scope.invalid = true

    if data and data.cooloff_time
      $scope.invalid = false
      $scope.cooloff = true


  $scope.onSuccess = (data) ->
    $scope.waiting = false
    cfpLoadingBar.complete()
    if not data or not data.login
      $scope.loginFailure()
    else if data.login and data.access
      $scope.loginSuccess()
    else if data.login and not data.access
      $scope.loginAccessRedirect()

  $scope.submit = () ->
    $scope.invalid = false
    $scope.badPermission = false
    if $scope.username == '' or $scope.password == ''
      $timeout ->
        $scope.invalid = true
      , 200
    else
      $scope.waiting = true
      cfpLoadingBar.start()
      Api.CSRF.get().$promise
        .then( (resp) ->
          Login.makeLoginRequest(
            $scope.username,
            $scope.password,
            resp.csrf_token,
            $scope.onSuccess,
            $scope.onError)
        , $scope.onError)
